import React, { useEffect, useState } from 'react';
import axios from '../../axiosConfig';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLoading } from '../../components/LoadingContext';
import BeneficiarioForm from './BeneficiarioForm';

const EditPromocion = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const [registro, setRegistro] = useState(null);
  const [enviando, setEnviando] = useState(false);
  const [erroresServidor, setErroresServidor] = useState(null);

  useEffect(() => {
    const cargar = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const { data } = await axios.get(`/promocion/${id}`, { headers: { Authorization: `Bearer ${token}` } });
        setRegistro(data);
      } catch (error) {
        toast.error('No se encontró el registro');
        navigate('/promocion');
      } finally {
        setLoading(false);
      }
    };
    cargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const guardar = async (payload) => {
    setEnviando(true);
    setErroresServidor(null);
    try {
      const token = localStorage.getItem('token');
      await axios.put(`/promocion/${id}`, payload, { headers: { Authorization: `Bearer ${token}` } });
      toast.success('Registro actualizado');
      navigate('/promocion');
    } catch (error) {
      if (error.response?.status === 422) {
        setErroresServidor(error.response.data.errors || { general: [error.response.data.message] });
      } else {
        toast.error('No se pudo actualizar el registro');
        console.error('Error actualizando beneficiarios sin datos:', error);
      }
    } finally {
      setEnviando(false);
    }
  };

  // El formulario toma sus valores iniciales al montarse: se espera al registro.
  if (!registro) return null;

  return (
    <BeneficiarioForm
      titulo="Editar beneficiarios sin datos"
      registro={registro}
      onGuardar={guardar}
      enviando={enviando}
      erroresServidor={erroresServidor}
    />
  );
};

export default EditPromocion;
